import { HCPEnrollmentFlowState } from '../types/hcpEnrollmentFlow.types'
import { createSlice } from '@reduxjs/toolkit'

const initialState: HCPEnrollmentFlowState = {
  staffFacilities: null,
  selectedProvider: null,
  providerFacilities: null,
  loggedInDetails: null,
}

const hcpEnrollmentFlowSlice = createSlice({
  name: 'hcpEnrollmentFlow',
  initialState: initialState,
  reducers: {
    updateEnrollmentStaffFacilitiesData: (
      state: HCPEnrollmentFlowState,
      action
    ) => {
      state.staffFacilities = action.payload
    },
    updateLoggedInDetails: (state: HCPEnrollmentFlowState, action) => {
      state.loggedInDetails = action.payload
    },
    updateSelectedProvider: (state: HCPEnrollmentFlowState, action) => {
      state.selectedProvider = action.payload
    },
    getEnrollmentStaffFacilitiesDataAction: () => {
      return
    },
    updateEnrollmentProviderFacilitiesData: (
      state: HCPEnrollmentFlowState,
      action
    ) => {
      state.providerFacilities = action.payload
    },
    getEnrollmentProviderFacilitiesDataAction: () => {
      return
    },
    getLoggedInDetailsAction: () => {
      return
    },
  },
})

export const {
  getEnrollmentStaffFacilitiesDataAction,
  updateEnrollmentStaffFacilitiesData,
  updateSelectedProvider,
  getEnrollmentProviderFacilitiesDataAction,
  updateEnrollmentProviderFacilitiesData,
  getLoggedInDetailsAction,
  updateLoggedInDetails,
} = hcpEnrollmentFlowSlice.actions
export default hcpEnrollmentFlowSlice.reducer
